import * as S from "./styles";

// O valor da variável é o próprio texto exibido na barra.
// Vazio/ausente (ex.: produção) => a barra não é renderizada.
const ENV_BANNER_LABEL = process.env.REACT_APP_ENV_BANNER;

const EnvironmentBanner = () => {
  if (!ENV_BANNER_LABEL) return null;

  return (
    <>
      <S.BannerSpacing />
      <S.Bar role="status">{ENV_BANNER_LABEL}</S.Bar>
    </>
  );
};

export default EnvironmentBanner;
